export default __webpack_public_path__ + "static/media/Bedroom_3_2.b45c22d4.png";